import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceHide20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_737)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.97529 4.91454L1.53042 0.469666L0.469762 1.53033L4.65936 5.71992C3.10029 6.78155 1.6484 8.07256 0.427743 9.51525C0.183993 9.79149 0.182899 10.2072 0.426666 10.4835L0.427743 10.4848C3.66755 14.3139 9.03597 17.7855 14.0249 15.0854L18.4698 19.5303L19.5304 18.4697L15.3408 14.28C16.8155 13.2758 18.1598 12.0641 19.3509 10.7374C19.3753 10.7101 19.3997 10.6828 19.4241 10.6554C19.7565 10.282 19.7572 9.71743 19.4242 9.34456C19.3999 9.31738 19.3754 9.29003 19.3509 9.26265C16.004 5.53447 10.9837 2.20392 5.97529 4.91454ZM7.08851 6.02775C11.2134 4.00413 15.2576 7.06966 17.9922 10C16.8749 11.1972 15.6317 12.3005 14.2591 13.1983L13.1288 12.068C15.2333 8.89037 11.2885 4.64827 7.93203 6.87127L7.08851 6.02775ZM9.03002 7.96926C10.9102 7.06954 12.8947 9.16464 12.0308 10.97L9.03002 7.96926ZM10.9701 12.0307L7.96933 9.0299C7.1053 10.8353 9.08991 12.9305 10.9701 12.0307ZM12.0681 13.1287C8.71161 15.3518 4.76667 11.1096 6.87136 7.93192L5.74105 6.80162C4.36841 7.69945 3.12515 8.80273 2.00788 10C4.74245 12.9304 8.78678 15.9959 12.9116 13.9722L12.0681 13.1287Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_737'>
        <rect
          width='20'
          height='20'
          fill='white'
          transform='matrix(-1 0 0 1 20 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

AppearanceHide20.displayName = 'AppearanceHide20';
export default AppearanceHide20;
